import EmberObject from '@ember/object';
import Route from 'mewe/routes/route';

export default Route.extend({
  model() {
    return EmberObject.extend({}).create();
  },
});
